import * as React from "react";
import { connect } from "react-redux";
import {
  Container,
  Dropdown,
  Accordion,
  Form,
  Button,
  Tab,
  Modal,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { resolve, reject } from "q";
import { FaPencilAlt } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { VendorService } from "../../Common/Services/VendorService";
import  VendorMasterSlideout  from "../../Modules/Masters/VendorMasterSlideout";
import paginationFactory from "react-bootstrap-table2-paginator";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
const { SearchBar } = Search;
import _ from "lodash";
import { TransactionService } from "../../Common/Services/TransactionService";

import createDOMPurify from "dompurify";

import moment from "moment";
class VendorMaster extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      coaList:[],
      activeTab: "first",
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      searcResult1: [],
      orderid: 0,
      selectedcolumn: "All",
      selectOptions: [
        { id: "All", name: "All" },
        { id: "Vendor Code", name: "Vendor Code" },
        { id: "Vendor Name", name: "Vendor Name" },
        { id: "Address", name: "Address" },
        { id: "Phone Number", name: "Phone Number" },
        { id: "Status", name: "Status" },
      ],
      formData: {
        id: 0,
        groupname: "",
        groupdesc: "",
        status: "Active",
      },
    };
  }
  componentDidMount() {
    let requestlist = { ...this.state.requestlist };
    this.getVendorMaster(requestlist);
    this.getCOA();
    this.getVendorGroups();
  }

    getCOA = () => {
        let requestlist = { ...this.state.requestlist };
        let coaListItems: any = [];
    
        TransactionService.GetCOA(requestlist)
          .then(async (result: any | null) => {
            if (result != null) {
              result.forEach((element) => {
                let item: any = {};
    
                item.id = element.accountID;
                item.name = `${element.accountCode} - ${element.accountName}`;
                coaListItems.push(item);
              });
              this.setState({ coaList: coaListItems});
            }
            resolve();
          })
          .catch((err: any) => {
            toast.error(`Server Error, ${err}`);
            reject();
          });
      };
    

  getVendorGroups = () => {
    VendorService.GetVendorGroups({})
      .then(async (result: any[] | null) => {
        if (result != null) {
          this.setState({ searcResult1: result });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  handleSelectedItem1 = (control: any, id: any) => {
    let searcResult1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );
    let chkisstatus = id == "Status" ? true : false;
    let chkisPhoneNumber = id == "Phone Number" ? true : false;
    let chkisaddress = id == "Address" ? true : false;
    let chkiscustomername = id == "Vendor Name" ? true : false;
    let chkiscustomercode = id == "Vendor Code" ? true : false;

    if (id == "All") {
      chkisstatus = true;
      chkisPhoneNumber = true;
      chkisaddress = true;
      chkiscustomername = true;
      chkiscustomercode = true;
    }

    this.setState(
      {
        searcResult: [],
        selectedcolumn: id,
        isstatus: chkisstatus,
        isphone_number: chkisPhoneNumber,
        isaddress: chkisaddress,
        iscompanyname: chkiscustomername,
        isvendorcode: chkiscustomercode,
      },
      () => {
        this.setState({ searcResult: searcResult1 });
      }
    );
  };

  getVendorMaster = (requestlist: any) => {
    VendorService.GetVendorlist(requestlist)
      .then(async (result: any[] | null) => {
        if (result != null) {
          result.forEach((element) => {
            debugger;
            let defaultname: any = element.vendorContact.filter(
              (x) => x.isDefault == true
            );
            if (defaultname.length > 0) {
              element.contactPerson = defaultname[0].firstname;
              element.phone_number = defaultname[0].phoneno;
            }
          });
          this.setState({ searcResult: result }, () => {});
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({
        showSlideout: true,
        vendorid: row.vendor_id,
        isSpinner: false,
      });
    },
  };

  rowEvents1 = {
    onClick: (e: any, row: any, rowIndex: any) => {
      const selectedVendorIds =
        row.vid && row.vid.trim() !== "" ? row.vid.split(",").map(Number) : [];
      const selectedAccountIds =
        row.accid && row.accid.trim() !== "" ? row.accid.split(",").map(Number) : [];

      this.setState({
        selectedGroupId: row.id,
        selectedVendorIds,
        selectedAccountIds,
        isSpinner: false,
        showGroups: true,
      });
    },
  };

  showNewSlideOut = () => {
    this.setState({ showSlideout: true, vendorid: 0, isSpinner: false });
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false, isSpinner: false });
    let requestlist = { ...this.state.requestlist };
    this.getVendorMaster(requestlist);
  };

  handleChange = (event: any, FieldType: string, index: any) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };

    if (FieldType === "description") {
      event.preventDefault();
      formData.groupdesc = event.target.value;
      this.setState({ formData, isStateChanged }, () => {});
    } else if (FieldType === "name") {
      event.preventDefault();
      formData.groupname = event.target.value;
      this.setState({ formData, isStateChanged }, () => {});
    }

    this.setState({ formData, isStateChanged, isSpinner: false }, () => {});
  };

  handleSave = () => {
    let isFormValid = true;
    let request: any = {};
    const { formData } = this.state;

    if (formData.groupname === "") {
      toast.error("Please enter group name.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }

    console.log("from data", this.state.formData);
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    this.setState({ isSpinner: true });
    if (isFormValid) {
      VendorService.SaveVendorGroup(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            (formData.groupname = ""), (formData.groupdesc = "");
            let message = "Group has been added.";
            toast.success(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });

            this.setState(
              {
                isSpinner: false,
                isStateChanged: false,
                formData,
              },
              () => {
                this.getVendorGroups();
              }
            );
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    }
  };

  handleAdd = () => {
    let isFormValid = true;
    let request: any = {};

    if (this.state.selectedVendorIds.length === 0) {
      toast.error("Please select at least one vendor.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }

    console.log("from data", this.state.formData);
    request.groupid = this.state.selectedGroupId;
    request.vid = this.state.selectedVendorIds.join(",");
    request.accid = this.state.selectedAccountIds.join(",");
    request = Object.assign({}, JSON.parse(JSON.stringify(request)));
    this.setState({ isSpinner: true });
    if (isFormValid) {
      VendorService.SaveVendorGroupDetails(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            let message = "Group has been updated.";
            toast.success(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });

            this.setState(
              {
                isSpinner: false,
                isStateChanged: false,
              },
              () => {
                this.getVendorGroups();
              }
            );
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    }
  };

  handleDelete = (row: any) => {
    this.setState({ isSpinner: true });
    VendorService.DeleteGrp({ id: row.id })
      .then(async (result: any | null) => {
        if (result) {
          let message = "Group has been deleted.";
          toast.success(message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });

          this.setState(
            {
              isSpinner: false,
              isStateChanged: false,
            },
            () => {
              this.getVendorGroups();
            }
          );
        } else {
          toast.error("Unable to delete group.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          this.setState({ isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };


  updateStatus = (e: any, rowIndex: number, row: any) => {
  const newStatus = e.target.checked;

  const request = {
    id: row.id,
    groupname: row.groupname,
    groupdesc: row.groupdesc,
    status: newStatus ? "Active" : "Inactive",
  };

  this.setState({ isSpinner: true });

  VendorService.SaveVendorGroup(request)
    .then((result: any | null) => {
      if (result !== null) {
        toast.success("Status updated successfully.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

        this.getVendorGroups();
      }
      this.setState({ isSpinner: false });
    })
    .catch((error) => {
      toast.error("Failed to update status.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSpinner: false });
    });
};


  handleEdit = (row) => {
    this.setState({
      editingIndex: row.id,
      editingName: row.groupname,
      editingDesc: row.groupdesc,
      showPopup: true,
    });
  };

  handleEditSave  = () => {
    let isFormValid = true;
    let request: any = {};
    const { editingIndex,editingName,editingDesc } = this.state;

    if (editingName === "") {
      toast.error("Please enter group name.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }
    request.id = editingIndex;
    request.groupname=editingName;
    request.groupdesc=editingDesc;
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(request))
    );
    this.setState({ isSpinner: true });
    if (isFormValid) {
      VendorService.SaveVendorGroup(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            let message = "Group has been updated.";
            toast.success(message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });

            this.setState(
              {
                isSpinner: false,
                isStateChanged: false,
                showPopup: false,
                editingIndex:0,
                editingName:"",
                editingDesc:"",

              },
              () => {
                this.getVendorGroups();
              }
            );
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    }
  };


  handleOnSelect = (row: any, isSelect: boolean) => {
    const vendorId = row.vendor_id;

    this.setState((prevState: any) => {
      let updatedVendorIds = [...prevState.selectedVendorIds];

      if (isSelect) {
        if (!updatedVendorIds.includes(vendorId)) {
          updatedVendorIds.push(vendorId);
        }
      } else {
        updatedVendorIds = updatedVendorIds.filter(
          (id: number) => id !== vendorId
        );
      }

      return { selectedVendorIds: updatedVendorIds };
    });
  };


  handleOnSelect1 = (row: any, isSelect: boolean) => {
    const vendorId = row.id;

    this.setState((prevState: any) => {
      let updatedVendorIds = [...prevState.selectedAccountIds];

      if (isSelect) {
        if (!updatedVendorIds.includes(vendorId)) {
          updatedVendorIds.push(vendorId);
        }
      } else {
        updatedVendorIds = updatedVendorIds.filter(
          (id: number) => id !== vendorId
        );
      }

      return { selectedAccountIds: updatedVendorIds };
    });
  };


  render() {
     const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Vendor Master'] ? permissions['Vendor Master'].includes('Add Vendor') : false;
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {
      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "25",
          value: 25,
        },
        {
          text: "50",
          value: 50,
        },

        {
          text: "All",
          value: this.state.searcResult.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };
    const { showSlideout } = this.state;

    const columns = [
      {
        searchable: this.state.isvendorcode,
        dataField: "vendorcode",
        text: "Vendor Code",
        sort: true,
      },

      {
        searchable: this.state.iscompanyname,
        dataField: "company_name",
        text: "Vendor Name",
        sort: true,
      },
      {
        searchable: this.state.isaddress,
        dataField: "address",
        text: "Vendor Address",
      },

      {
        searchable: this.state.isphone_number,
        dataField: "contactPerson",
        text: "Contact Person",
      },

      {
        searchable: this.state.isphone_number,
        dataField: "phone_number",
        text: "Contact Phone",
      },

      {
        dataField: "status",
        text: "Status",
        sort: true,
        headerStyle: { width: "200px" },
        headerClasses: "text-center",
        classes: "text-center",

        searchable: this.state.isstatus,
        //searchable:this.state.isdueDate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <span
                  className={
                    row.status === "Active"
                      ? "badge badge-pill badge-primary color-green"
                      : "badge badge-pill badge-primary color-red"
                  }
                >
                  {" "}
                  {row.status}{" "}
                </span>
              </EllipsisWithTooltip>
            </>
          );
        },
      },
    ];

    const grpcolumns = [
      {
        searchable: true,
        dataField: "groupname",
        text: "Group Name",
        sort: true,
        headerClasses: "text-start",
        classes: "text-start",
      },
      {
        dataField: "Attachment",
        text: "",
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <FaPencilAlt
              onClick={() => this.handleEdit(row)}
              style={{
                cursor: "pointer",
              }}
            />
          );
        },
      },
      {
        dataField: "Attachment",
        text: "",
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let itemDetailConfirmModalContent = [
            {
              title: "Delete Group",
              desc: "Are you sure you want to delete?",
              cancleAction: "Cancel",
              ActionTrue: "Delete",
            },
          ];

          const isDeletable = (!row.vid || row.vid.trim() === "") && (!row.accid || row.accid.trim() === "");

          if (!isDeletable) {
            return null; 
          }

          return (
            <Dropdown
              className="more-action confirmation-modal"
              tabIndex={this.state.tabDisable}
            >
              <Dropdown.Toggle
                className="btn-outline-primary btn btn-primary more fa-trash"
                id="dropdown-more-delete"
                tabIndex={this.state.tabDisable}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={itemDetailConfirmModalContent}
                  ishandleDeletePosition={this.handleDelete.bind(this, row)}
                />
              </Dropdown.Menu>
            </Dropdown>
          );
        },
      },
         {
               dataField: 'status',
               text: 'Active',
               headerClasses: 'text-center',
               classes: 'text-center',
               
               headerStyle: { width: '80px' },
               hidden: false,
               editable: false,
               headerAttrs: (column, colIndex) => (
                 { 'tabIndex': '-1' }
               ),
               formatter: (cell: any, row: any, rowIndex: any) => {
                 let id = "txtdescription" + rowIndex + "txt";
                 let disable = false;
                 return (
                   <div>
                        <Form.Check
                     className="knob"
                             // tabIndex={this.state.tabEnable}
                             id={"txtstatus" + rowIndex + "txt"}
                             type="switch"
                             checked={row.status === "Active"} 
                              onChange={(e) => this.updateStatus(e, rowIndex, row)}
                             autoComplete="off"
                             title=""
                           />
     
                   </div>
         
                 );
         
         
         
               },
         
             },
    ];

    const grpcolumns1 = [
      {
        searchable: true,
        headerStyle: { width: "500px" },
        dataField: "company_name",
        text: "Select Vendor to add",
        sort: false,
        headerClasses: "text-start",
        classes: "text-start",
      },
    ];


    
    const grpcolumns2 = [
      {
        searchable: true,
        headerStyle: { width: "500px" },
        dataField: "name",
        text: "Select COA to add",
        sort: false,
        headerClasses: "text-start",
        classes: "text-start",
      },
    ];

    return (
      <>
        <React.Fragment>
          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex  ">
              Vendor Master
              <div className="action-group d-flex flex-row ml-auto">
                {this.state.activeTab === "first" ? (
                  hasAddPermission && <Button onClick={this.showNewSlideOut}>Add Vendor</Button>
                                    ) : (
                  <Button
                    onClick={() => {
                      this.setState({ showGroups: false });
                    }}
                  >
                    Add Group
                  </Button>
                )}
              </div>
            </div>

            <Tab.Container
              activeKey={this.state.activeTab}
              onSelect={(selectedKey) =>
                this.setState({ activeTab: selectedKey })
              }
              transition={false}
            >
              <section className="pb-3">
                <Nav className="nav nav-underline border-bottom">
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="first">
                      All Vendors
                      <span className="badge badge-light">{this.state.searcResult.length}</span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="second">Groups
                    <span className="badge badge-light">{this.state.searcResult1.length}</span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </section>

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <section className="mt-3">
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.searcResult}
                      columns={columns}
                      //className="table table-striped table-borderless align-middle"
                      search
                    >
                      {(props) => (
                        <div>
                          <section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>

                            <div className="col-12 col-md-2">
                                <SingleDropdownListWithoutSearch
                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(
                                    this,
                                    1
                                  )}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}
                                />
                            </div>
                          </section>
                          <section className="pb-3">
                            <div className="table-responsive divbottom">
                              <div className="ml-auto transactions-list payroll-tbl1">
                                <BootstrapTable
                                  {...props.baseProps}
                                  rowEvents={this.rowEvents}
                                  keyField="id"
                                  pagination={paginationFactory(options)}
                                />
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    </ToolkitProvider>
                  </section>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <div className="row">
                    <section className="mt-3 col-3">
                      <ToolkitProvider
                        keyField="id"
                        data={this.state.searcResult1}
                        columns={grpcolumns}
                        className="table table-striped table-borderless align-middle"
                        search
                      >
                        {(props) => (
                          <div>
                            <section className="d-flex flex-wrap gap-3 pb-2">
                              <div className="position-relative">
                                <SearchBar {...props.searchProps} />
                              </div>
                            </section>
                            <section className="pb-3">
                              <div className="table-responsive divbottom">
                                <div className="ml-auto transactions-list">
                                  <BootstrapTable
                                    {...props.baseProps}
                                    rowEvents={this.rowEvents1}
                                    keyField="id"
                                    rowStyle={(row, rowIndex) => {
                                      return row.id == this.state.selectedGroupId
                                        ? {
                                            backgroundColor: "#c8e6c9",
                                            fontWeight: "bold",
                                            borderLeft: "4px solid #388e3c",
                                          }
                                        : {};
                                    }}
                                    // pagination={paginationFactory(options)}
                                  />
                                </div>
                              </div>
                            </section>
                          </div>
                        )}
                      </ToolkitProvider>
                    </section>
                    {this.state.showGroups ? (
                      <>
                      <section className="mt-3 col-4">
                        <ToolkitProvider
                          keyField="vendor_id"
                          // data={this.state.searcResult}
                            data={[
                            ...this.state.searcResult.filter((x) =>
                              this.state.selectedVendorIds.includes(x.vendor_id)
                            ),
                            ...this.state.searcResult.filter(
                              (x) => !this.state.selectedVendorIds.includes(x.vendor_id)
                            ),
                          ]}
                          columns={grpcolumns1}
                          //  className="table table-striped table-borderless align-middle"
                          search
                        >
                          {(props) => (
                            <div>
                              <section className="d-flex flex-wrap gap-3 pb-2">
                                <div className="position-relative">
                                  <SearchBar {...props.searchProps} />
                                </div>
                              </section>
                              <section className="">
                                <div className="table-responsive divbottom">
                                  <div
                                    className="ml-auto transactions-list scroll p-0"
                                    style={{ maxHeight: "450px" }}
                                  >
                                    <BootstrapTable
                                      {...props.baseProps}
                                      keyField="vendor_id"
                                      selectRow={{
                                        mode: "checkbox",
                                        clickToSelect: false,
                                        hideSelectAll: true,
                                        selected: this.state.searcResult
                                          .filter((x) =>
                                            this.state.selectedVendorIds.includes(
                                              x.vendor_id
                                            )
                                          )
                                          .map((row) => row.vendor_id),
                                        onSelect: this.handleOnSelect,
                                        // onSelectAll: this.handleOnSelectAllApproval,
                                        hideSelectColumn: false,
                                      }}
                                      // pagination={paginationFactory(options)}
                                    />
                                  </div>
                                </div>
                              </section>
                            </div>
                          )}
                        </ToolkitProvider>
                        <div className="">
                          {/* <Button
                            id="btnSaveVendor"
                            variant="primary"
                            type="button"
                            onClick={this.handleAdd}
                          >
                            Add
                          </Button> */}
                          <div
                            className={"footer-section-new viewer-panel"}
                            style={{
                              minWidth: "83.6%",
                              width: "992px",
                              maxWidth: "100%",
                            }}
                          >
                            <div>
                              <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                                {this.state.isStateChanged && (
                                  <div className="mr-auto message">
                                    <span style={{ color: "#065a8c" }}>
                                      You have unsaved changes
                                    </span>
                                  </div>
                                )}

                                <div className="d-flex gap-3 align-items-center" style={{paddingRight:'15px'}}>
                                  <Button
                                    id="btnSubmit"
                                    variant="primary"
                                    type="button"
                                    onClick={this.handleAdd}
                                  >
                                    {"Add"}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section className="mt-3 col-5">
                        <ToolkitProvider
                          keyField="id"
                          // data={this.state.searcResult}
                            data={[
                            ...this.state.coaList.filter((x) =>
                              this.state.selectedAccountIds.includes(x.id)
                            ),
                            ...this.state.coaList.filter(
                              (x) => !this.state.selectedAccountIds.includes(x.id)
                            ),
                          ]}
                          columns={grpcolumns2}
                          //  className="table table-striped table-borderless align-middle"
                          search
                        >
                          {(props) => (
                            <div>
                              <section className="d-flex flex-wrap gap-3 pb-2">
                                <div className="position-relative">
                                  <SearchBar {...props.searchProps} />
                                </div>
                              </section>
                              <section className="">
                                <div className="table-responsive divbottom">
                                  <div
                                    className="ml-auto transactions-list scroll p-0"
                                    style={{ maxHeight: "450px" }}
                                  >
                                    <BootstrapTable
                                      {...props.baseProps}
                                      keyField="id"
                                      selectRow={{
                                        mode: "checkbox",
                                        clickToSelect: false,
                                        hideSelectAll: true,
                                        selected: this.state.coaList
                                          .filter((x) =>
                                            this.state.selectedAccountIds.includes(
                                              x.id
                                            )
                                          )
                                          .map((row) => row.id),
                                        onSelect: this.handleOnSelect1,
                                        // onSelectAll: this.handleOnSelectAllApproval,
                                        hideSelectColumn: false,
                                      }}
                                      // pagination={paginationFactory(options)}
                                    />
                                  </div>
                                </div>
                              </section>
                            </div>
                          )}
                        </ToolkitProvider>
                        <div className="">
                          {/* <Button
                            id="btnSaveVendor"
                            variant="primary"
                            type="button"
                            onClick={this.handleAdd}
                          >
                            Add
                          </Button> */}
                          <div
                            className={"footer-section-new viewer-panel"}
                            style={{
                              minWidth: "83.6%",
                              width: "992px",
                              maxWidth: "100%",
                            }}
                          >
                            <div>
                              <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                                {this.state.isStateChanged && (
                                  <div className="mr-auto message">
                                    <span style={{ color: "#065a8c" }}>
                                      You have unsaved changes
                                    </span>
                                  </div>
                                )}

                                <div className="d-flex gap-3 align-items-center" style={{paddingRight:'15px'}}>
                                  <Button
                                    id="btnSubmit"
                                    variant="primary"
                                    type="button"
                                    onClick={this.handleAdd}
                                  >
                                    {"Update"}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      </>
                    ) : (
                      <section className="mt-3 col-8">
                        <Form.Label className="font-semibold mb-3 fs-6">
                          Add Group
                        </Form.Label>
                        <div className="col-12 col-md-6">
                          <Form.Label className="font-semibold">
                            Group Name
                          </Form.Label>
                          <Form.Control
                            tabIndex={this.state.tabEnable}
                            id="txtdescription"
                            placeholder="Please enter details"
                            value={this.state.formData.groupname}
                            onChange={(event: any) =>
                              this.handleChange(event, "name", 0)
                            }
                            autoComplete="off"
                            maxLength={200}
                            disabled={false}
                            title=""
                          />
                        </div>
                        <div className="col-12 col-md-6 mt-3">
                          <Form.Label className="font-semibold">
                            Group Description
                          </Form.Label>
                          <Form.Control
                            tabIndex={this.state.tabEnable}
                            id="txtdescription"
                            as="textarea"
                            rows={3}
                            placeholder="Please enter details"
                            value={this.state.formData.groupdesc}
                            onChange={(event: any) =>
                              this.handleChange(event, "description", 0)
                            }
                            autoComplete="off"
                            maxLength={200}
                            disabled={false}
                            title=""
                          />
                        </div>
                        <div className="mt-3">
                          <Button
                            id="btnSaveVendor"
                            variant="primary"
                            type="button"
                            onClick={this.handleSave}
                          >
                            Save
                          </Button>
                        </div>
                      </section>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>

            {this.state.isSpinner && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}

            {showSlideout && (
              <VendorMasterSlideout
                closeSlideOut={this.closeSlideOut}
                vendorid={this.state.vendorid}
                id={this.state.id}
              ></VendorMasterSlideout>
            )}

            {/* Edit modal */}
            <Modal
              show={this.state.showPopup}
              onHide={() => {
                this.setState({ showPopup: false });
              }}
            >
              <Modal.Header>
                <Modal.Title>Edit Group Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group controlId="formDescription">
                  <Form.Label className="font-semibold">Group Name</Form.Label>
                  <Form.Control
                    value={this.state.editingName}
                    onChange={(e) => {
                      this.setState({ editingName: e.target.value });
                    }}
                    placeholder="Edit the description..."
                  />
                  <Form.Label className="font-semibold mt-2">
                    Group Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={this.state.editingDesc}
                    onChange={(e) => {
                      this.setState({ editingDesc: e.target.value });
                    }}
                    placeholder="Edit the description..."
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => {
                    this.setState({ showPopup: false });
                  }}
                >
                  Cancel
                </Button>
                <Button variant="primary" onClick={this.handleEditSave}>
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
          </Container>
        </React.Fragment>
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(VendorMaster);